document.addEventListener('DOMContentLoaded', () => {
  const selectElement = (selector, logMessage) => {
    const element = document.querySelector(selector)
    if (!element) {
      console.warn(logMessage)
      return
    }
    return element
  }

  const stickyAddToCartAliasElement = selectElement('[data-sticky-atc-button-alias]', 'Warning: stickyAddToCartAliasElement not found')
  const stickyAddToCart = selectElement('[data-sticky-atc-button]', 'Warning: stickyAddToCart not found')
  const footerElement = selectElement('.new-footer', 'Warning: footerElement not found')

  const toggleClasses = (isIntersecting) => {
    const action = isIntersecting ? 'remove' : 'add'
    stickyAddToCart?.classList[action]('active')
  }

  const observerCallback = (entries) => {
    entries.forEach(entry => toggleClasses(entry.isIntersecting))
  }

  const observer = new IntersectionObserver(observerCallback, { root: null, threshold: 0.1 })
  if (stickyAddToCartAliasElement) {
    observer.observe(stickyAddToCartAliasElement)
  } else {
    console.warn('stickyAddToCartAliasElement not found, observer not initiated.')
  }

  const footerObserverCallback = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        observer.disconnect()
        toggleClasses(true)
      } else if (stickyAddToCartAliasElement) {
        observer.observe(stickyAddToCartAliasElement)
      }
    })
  }

  const footerObserver = new IntersectionObserver(footerObserverCallback, { root: null, threshold: 0.1 })
  if (footerElement) {
    footerObserver.observe(footerElement)
  } else {
    console.warn('footerElement not found, footerObserver not initiated.')
  }

  if (stickyAddToCart) {
    const productInfo = selectElement('product-info', 'Warning: productInfo not found')
    const productInfoInputs = productInfo?.querySelectorAll('product-info [data-product-variant-radio]')
    const stickyAddToCartVariant = selectElement('[data-sticky-atc-button-variant]', 'Warning: stickyAddToCartVariant not found')

    const updateInputField = () => {
      setTimeout(() => {
        const getSelectedVariantField = selectElement('product-info form .product-variant-id', 'Warning: getSelectedVariantField not found')
        const getStickyCartFormVariantID = selectElement('[data-sticky-atc-button] .product-variant-id', 'Warning: getStickyCartFormVariantID not found')
        if (getSelectedVariantField && getStickyCartFormVariantID) {
          getStickyCartFormVariantID.value = getSelectedVariantField.value
        }
      }, 300)
    }

    const updateVariant = (selectedValue) => {
      if (stickyAddToCartVariant) {
        stickyAddToCartVariant.innerHTML = selectedValue
      }
    }

const updatePriceField = () => {
    // When the price block is on sale, --regular is the STRUCK price (the
    // compare-at, or the pre-deal original) and --sale is what the shopper
    // actually pays. Reading --regular first put the struck price in the
    // sticky bar: a daily-deal PDP showed $27.30 in the hero and $39 down here.
    // Same bug applied to any genuinely marked-down product.
    // Direct querySelector, not selectElement: a miss here is the normal case
    // on a full-price product, and selectElement console.warns on every miss
    // (this runs on a 200ms interval).
    let formPriceField = document.querySelector(
      "product-info .price--on-sale .price-item.price-item--sale"
    );
    if (!formPriceField) {
      formPriceField = selectElement(
        "product-info .price-item.price-item--regular",
        "Warning: formPriceField not found"
      );
    }
    if (!formPriceField) {
      formPriceField = selectElement(
        ".price-item",
        "Warning: formPriceField2 not found"
      );
    }

    const priceValue = formPriceField
      ? formPriceField.textContent.trim()
      : "Price not found";

    // On sale, carry the struck original across too, so a variant change keeps
    // the same "was / now" pair the server rendered instead of collapsing to a
    // bare number.
    const struckEl = document.querySelector(
      "product-info .price--on-sale .price__sale s"
    );
    const struckValue = struckEl ? struckEl.textContent.trim() : "";

    const stickyAddToCartPrice = selectElement(
      "[data-sticky-atc-button-price]",
      "Warning: stickyAddToCartPrice not found"
    );
    if (stickyAddToCartPrice) {
      if (struckValue && priceValue !== struckValue) {
        stickyAddToCartPrice.innerHTML =
          '<span class="dd-sticky-price"><s class="dd-was"></s> <span class="dd-now"></span></span>';
        stickyAddToCartPrice.querySelector(".dd-was").textContent = struckValue;
        stickyAddToCartPrice.querySelector(".dd-now").textContent = priceValue;
      } else {
        stickyAddToCartPrice.textContent = priceValue;
      }
    }

    if (stickyAddToCartPrice) {
      if (stickyAddToCartPrice.classList.contains("discount-applied")) {
        stickyAddToCartPrice.classList.remove("discount-applied");
      }
    }
};

    productInfoInputs?.forEach(radioButton => {
      radioButton.addEventListener('change', () => {
        updateVariant(radioButton.value)
        updateInputField()
        updatePriceField()
      })
    })

    // Variant updates replace the price asynchronously. Re-read it from the
    // existing variant event instead of starting a new 200ms polling interval
    // for every radio change.
    window.addEventListener('variantUpdated', updatePriceField)
  }
})
